import React from 'react';
import { FiFileText, FiInfo, FiBookOpen, FiGlobe, FiTarget, FiGrid, FiEye } from 'react-icons/fi';
import { FaBuilding } from 'react-icons/fa';
import BankSidebar from '../components/BankSidebar';

export default function CustomerPayment() {
  return (
    <div className="flex h-full font-sans overflow-hidden">
      <BankSidebar />
      <div className="flex-1 bg-[#a6e4e7] overflow-y-auto relative">
        <div className="p-4 flex items-center space-x-2 text-teal-800">
          <FiFileText className="text-lg opacity-60" />
          <span className="font-medium text-[15px]">Enter payment received from customer</span>
        </div>

        <div className="px-4 pb-12">
          {/* Form Section (White Box) */}
          <div className="bg-white border border-gray-200 p-5 shadow-sm mb-6">
            <div className="grid grid-cols-[220px_1fr] gap-y-4 items-center text-[13px]">
              <div className="font-bold text-gray-800">Company</div>
              <div className="flex items-center text-gray-800">
                <FaBuilding className="text-[#800080] mr-2 text-[14px]" /> WONG CHING YEE (WONG CHING YEE)
              </div>

              <div className="font-bold text-gray-800">Date</div>
              <div className="flex items-center space-x-2">
                <input type="text" value="05/20/2026" readOnly className="border border-gray-300 px-2 py-1 w-28 bg-white text-gray-800 outline-none" />
                <span className="text-gray-400 text-sm border border-gray-300 px-1.5 py-0.5 bg-gray-50 flex items-center justify-center cursor-pointer hover:bg-gray-100">📅</span>
                <span className="text-gray-500 text-[12px]">Now - Invoice date</span>
              </div>

              <div className="font-bold text-gray-800">Payment method</div>
              <div className="flex items-center space-x-2">
                <select className="border border-gray-300 bg-[#a6e4e7] px-2 py-1 w-48 outline-none text-gray-800 shadow-sm">
                  <option>Bank transfer</option>
                </select>
                <FiInfo className="text-gray-400 text-[16px] cursor-pointer hover:text-gray-600" />
              </div>

              <div className="font-bold text-gray-800">Account to credit</div>
              <div>
                <select className="border border-gray-300 bg-[#a6e4e7] px-2 py-1 w-48 outline-none text-gray-800 shadow-sm">
                  <option>BANK OF CHI...</option>
                </select>
              </div>

              <div className="font-bold text-gray-800">Number <span className="font-normal italic text-gray-600">(Check/Transfer N°)</span></div>
              <div>
                <input type="text" className="border border-gray-300 px-2 py-1 w-full max-w-[300px] outline-none shadow-inner" />
              </div>

              <div className="font-bold text-gray-800">Sender <span className="font-normal italic text-gray-600">(Check/Transfer sender)</span></div>
              <div>
                <input type="text" defaultValue="WONG CHING YEE" className="border border-gray-300 px-2 py-1 w-full max-w-[300px] outline-none shadow-inner" />
              </div>

              <div className="font-bold text-gray-800">Bank <span className="font-normal italic text-gray-600">(Bank of Check)</span></div>
              <div>
                <input type="text" className="border border-gray-300 px-2 py-1 w-full max-w-[300px] outline-none shadow-inner" />
              </div>

              <div className="font-bold text-gray-800 self-start pt-1.5">Comments</div>
              <div>
                <textarea className="border border-gray-300 px-2 py-1 w-full max-w-4xl h-16 outline-none resize-none shadow-inner"></textarea>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto">
            <table className="min-w-full text-[12px] text-gray-800">
              <thead>
                <tr className="text-gray-600">
                  <th className="p-2 font-normal text-left align-bottom">Invoice</th>
                  <th className="p-2 font-normal text-left align-bottom">Date</th>
                  <th className="p-2 font-normal text-center align-bottom">Payment<br/>due on</th>
                  <th className="p-2 font-normal text-center align-bottom">Currency</th>
                  <th className="p-2 font-normal text-right align-bottom">Amount (inc. of<br/>tax), original<br/>currency</th>
                  <th className="p-2 font-normal text-right align-bottom">Received,<br/>original<br/>currency</th>
                  <th className="p-2 font-normal text-right align-bottom">Remaining<br/>amount, original<br/>currency</th>
                  <th className="p-2 font-normal text-right align-bottom">Payment<br/>amount, original<br/>currency</th>
                  <th className="p-2 font-normal text-right align-bottom">Amount<br/>(inc. tax)</th>
                  <th className="p-2 font-normal text-right align-bottom">Received</th>
                  <th className="p-2 font-normal text-right align-bottom">Remaining<br/>amount to take</th>
                  <th className="p-2 font-normal text-right align-bottom">Payment<br/>amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-[#eaf8f9] border-t border-b border-teal-100">
                  <td className="p-2 whitespace-nowrap text-[#008000]">
                    <FiFileText className="inline mr-1.5 text-[#5bc0be]" /> FA2605-0041
                  </td>
                  <td className="p-2 text-gray-700">05/20/2026</td>
                  <td className="p-2 text-center text-gray-700">05/21/2026</td>
                  <td className="p-2 text-center text-gray-700">HKD</td>
                  <td className="p-2"></td>
                  <td className="p-2"></td>
                  <td className="p-2"></td>
                  <td className="p-2"></td>
                  <td className="p-2 text-right text-gray-700">2,500.00</td>
                  <td className="p-2 text-right text-gray-700">0.00</td>
                  <td className="p-2 text-right text-gray-700">2,500.00</td>
                  <td className="p-1.5 text-right whitespace-nowrap">
                    <div className="flex items-center justify-end">
                      <span className="text-gray-500 mr-1.5 font-serif font-bold text-[16px] leading-none">↳</span>
                      <input type="text" defaultValue="2500" className="w-20 border border-gray-300 px-1.5 py-0.5 text-right outline-none bg-white shadow-inner" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Action Area */}
          <div className="flex flex-col items-center mt-12 pb-8">
            <label className="flex items-center text-[13px] text-gray-800 mb-4 cursor-pointer">
              <input type="checkbox" defaultChecked className="mr-2 w-3.5 h-3.5 accent-[#0000a0]" />
              Classify automatically all standard, down payment or replacement invoices as "Paid" when payment is done entirely.
            </label>
            <button className="bg-[#0000a0] text-white px-10 py-1.5 rounded shadow-sm hover:bg-blue-900 font-bold text-sm tracking-wide">
              PAY
            </button>
          </div>
        </div>

        {/* Floating Action Menu */}
        <div className="fixed right-4 top-1/2 -translate-y-1/2 flex flex-col space-y-3 z-50">
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 cursor-pointer hover:bg-gray-50 text-gray-600">
            <FiBookOpen className="text-lg" />
          </div>
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 cursor-pointer hover:bg-gray-50 text-gray-600 font-serif font-bold">
            A
          </div>
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 cursor-pointer hover:bg-gray-50 text-gray-600">
            <FiTarget className="text-lg" />
          </div>
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 cursor-pointer hover:bg-gray-50 text-gray-600">
            <FiGrid className="text-lg" />
          </div>
          <div className="w-9 h-9 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 cursor-pointer hover:bg-gray-50 text-[#0000a0]">
            <FiEye className="text-lg" />
          </div>
        </div>
      </div>
    </div>
  );
}